<template>
  <div class="h-full duration-200 relative bg-white flex" ref="main">
    <q-btn
      v-if="$route.query.asset"
      color="primary"
      icon="arrow_back"
      label="Back to Maintenance List"
      nocap
      flat
      class="no-underline absolute top-0 left-0 mt-3"
      @click="backToMain"
    />
    <div class="fit flex flex-no-wrap justify-end items-end overflow-hidden">
      <div
        class="flex-1 flex flex-col gap-4 relative p-4"
        style="height: calc(100% - (36px))"
      >
        <div
          class="flex relative gap-3 shadow rounded"
          :style="{ height: isNotificationExpanded ? '200px' : '26px' }"
        >
          <div class="w-3/5" v-if="isNotificationExpanded">
            <q-card-section class="fit">
              <MaintenanceTable data="notification" />
            </q-card-section>
          </div>
          <div class="flex-1 flex" v-if="isNotificationExpanded">
            <q-card-section class="fit">
              <NotificationConfig />
            </q-card-section>
          </div>
          <div
            class="font-bold text-sm fit flex items-center pl-2"
            v-if="!isNotificationExpanded"
          >
            Notification Panel
          </div>
          <q-btn
            class="absolute right-0 top-0 text-xs"
            color="primary"
            :icon="isNotificationExpanded ? 'expand_less' : 'expand_more'"
            no-caps
            padding="xs sm"
            dense
            @click="isNotificationExpanded = !isNotificationExpanded"
          >
            <q-tooltip content-class="bg-black">
              {{
                isNotificationExpanded
                  ? 'Minimize Notification'
                  : 'Expand Notification'
              }}
            </q-tooltip>
          </q-btn>
        </div>
        <q-card class="flex-1 shadow">
          <q-card-section class="fit pt-0">
            <MainContent />
          </q-card-section>
        </q-card>
        <div
          class="flex items-center absolute top-0 right-0 gap-2"
          style="transform: translate(-12px, -19px)"
          v-if="store.edited"
        >
          <div class="h-full flex items-center">There are unsaved changes</div>
          <q-btn
            v-if="$route.query.asset"
            color="danger"
            label="Cancel"
            unelevated
            nocap
            padding="xs lg"
            class="no-underline text-sm"
            @click="cancel()"
          />
          <q-btn
            v-if="$route.query.asset && store.edited"
            label="Save"
            unelevated
            color="primary"
            nocap
            padding="xs lg"
            class="no-underline text-sm"
            @click="save"
          />
        </div>
      </div>
      <VehicleProfile />
    </div>
    <slot class="absolute h-full" style="left: 0"> </slot>
  </div>
</template>

<script setup>
import { watch, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { useRefHistory } from '@vueuse/core';
import { store } from '../api/api';

import VehicleProfile from './profile/VehicleProfile.vue';
import MaintenanceTable from './components/MaintenanceTable.vue';
import NotificationConfig from './notification/NotificationConfig.vue';
import MainContent from './MainContent.vue';

const props = defineProps({ id: { default: null } });

const route = useRoute();
const router = useRouter();

const main = ref();
async function save() {
  await store.updateData(props.id, main.value);
}
async function cancel() {
  // await store.getData(props.id);
  store.state = await store.transformData();
  setTimeout(() => {
    store.edited = false;
  }, 0);
}
async function backToMain() {
  if (store.edited) {
    if (confirm('Unsaved changes will be lost, leave page?')) {
      store.state = await store.transformData();
      router.push({
        path: route.fullPath,
        query: { asset: null },
      });
    }
  } else {
    router.push({
      path: route.fullPath,
      query: { asset: null },
    });
  }
}
watch(
  () => props.id,
  async (v) => {
    if (props.id) {
      await store.getData(v);
      store.edited = false;
    } else {
      store.data = null;
    }
  },
  { immediate: true },
);

watch(
  () => store.state,
  () => {
    if (!store.fetching && !isEmpty(store.state)) {
      store.edited = true;
    }
  },
  { deep: true },
);
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

const isNotificationExpanded = ref(false);
</script>

<style lang="scss" scoped></style>
